import { useUpdateEffect } from 'react-use';

import { resetGalleryStore } from '@/components/Gallery/gallery.store';
import { ModalHeader } from '@/components/Modal';
import { Modal } from '@/components/Modal/Modal2';
import {
  selectActiveTab,
  selectNomenclatureStoreSelectedRow,
  selectVariant,
  useNomenclatureStore,
  useNomenclatureStoreActions,
  useNomenclatureStoreContextWindowsState,
} from '@/components/nomenclature/useNomenclatureStore';

import { ExpertDataForm } from './ExpertData';
import { ImagesForm } from './Images';
import { InstructionForPharmacistTab } from './InstructionForPharmacist';
import { InstructionTab } from './InstructionTab/InstructionTab';
import { LinksForm } from './Links';
import { NomenclatureForm } from './NomenclatureForm';
import { NomenclatureModalTabbar } from './NomenclatureModalTabbar';
import { ReceptionFeaturesForm } from './ReceptionFeatures/ReceptionFeaturesForm';

// ----------------------------------------------------------------------

export const NomenclatureDuplicateModal = () => {
  const { isDuplicateModalVisible } = useNomenclatureStoreContextWindowsState();
  const { closeDuplicateModal, setPreferredTab, setActiveTab, resetSelectedRow, setVariant } =
    useNomenclatureStoreActions();

  const activeTab = useNomenclatureStore(selectActiveTab);
  const variant = useNomenclatureStore(selectVariant);

  const drug = useNomenclatureStore(selectNomenclatureStoreSelectedRow);

  const handleClose = () => {
    closeDuplicateModal();
    setPreferredTab('general');
    setActiveTab('general');
    resetSelectedRow();
    resetGalleryStore();
  };

  useUpdateEffect(() => {
    if (isDuplicateModalVisible) {
      setVariant('duplicate');
    } else {
      handleClose();
    }
  }, [isDuplicateModalVisible]);

  if (!drug || !variant) {
    return null;
  }

  return (
    <Modal open={isDuplicateModalVisible} onClose={closeDuplicateModal}>
      <ModalHeader title={['Номенклатура', 'Создание записи']} onClose={closeDuplicateModal} />

      <NomenclatureModalTabbar variant="duplicate" />

      {/*
       key update is required to reset the form if another product is selected
       Fix bug in safari
       */}
      {activeTab === 'general' && (
        <NomenclatureForm variant={variant} key={drug.id} drug={drug} onClose={handleClose} />
      )}

      {activeTab === 'additionalCodesAndLinks' && (
        <LinksForm key={drug.id} variant={variant} drug={drug} onClose={handleClose} />
      )}

      {activeTab === 'expertData' && <ExpertDataForm variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'instruction' && <InstructionTab variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'receptionFeatures' && (
        <ReceptionFeaturesForm variant={variant} drug={drug} onClose={handleClose} />
      )}

      {activeTab === 'images' && <ImagesForm variant={variant} drug={drug} onClose={handleClose} />}

      {activeTab === 'instructionForPharmacist' && drug && (
        <InstructionForPharmacistTab variant={variant} drug={drug} onClose={handleClose} />
      )}
    </Modal>
  );
};
